<template>
  <div class="layout-header">
    <div class="layout-header-left">
      JSH-嘉盛泓
    </div>
    <div class="layout-header-right">
      <layout-menu />
      <el-dropdown @command="handleClick">
        <span class="el-dropdown-link">
          {{ user_name }}<i class="iconfont icon-xiajiantou" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item>用户信息</el-dropdown-item> -->
          <el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog :visible.sync="userDialogVisible" width="370px" :show-close="false" :before-close="userHandleClose" :close-on-click-modal="false">
      <template slot="title">
        <el-divider content-position="left">{{ userDialogTitle }}</el-divider>
      </template>
      <el-form ref="change_form" :rules="changeRules" :model="change_form" label-width="80px">
        <el-form-item label="原密码" prop="old_pwd">
          <el-input v-model="change_form.old_pwd" :type="old_flag?'text':'password'" style="border:1px solid #fff;width:250px;" placeholder="请输入密码">
            <i slot="suffix" :class="[old_flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="old_flag=!old_flag" />
          </el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="new_pwd">
          <el-input v-model="change_form.new_pwd" :type="new_flag?'text':'password'" style="border:1px solid #fff;width:250px;" placeholder="请输入密码">
            <i slot="suffix" :class="[new_flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="new_flag=!new_flag" />
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm_pwd">
          <el-input v-model="change_form.confirm_pwd" :type="confirm_flag?'text':'password'" style="border:1px solid #fff;width:250px;" placeholder="请输入密码">
            <i slot="suffix" :class="[confirm_flag?'el-icon-minus':'el-icon-view']" style="margin-top:8px;font-size:18px;" autocomplete="auto" @click="confirm_flag=!confirm_flag" />
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="userHandleClose">取 消</el-button>
        <el-button type="primary" @click="userHandleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetLogout, PostChangePwd } from '../api/api'
import LayoutMenu from './layout-menu'
export default {
  name: 'LayoutHeader',
  components: { LayoutMenu },
  data () {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.change_form.new_pwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    var validateOldPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var validateNewPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.change_form.confirm_pwd !== '') {
          this.$refs.change_form.validateField('confirm_pwd')
        }
        callback()
      }
    }
    return {
      user_name: JSON.parse(localStorage.getItem('user_info')).user_name,
      userDialogTitle: '修改密码',
      userDialogVisible: false,
      old_flag: false,
      new_flag: false,
      confirm_flag: false,
      change_form: {
        old_pwd: '',
        new_pwd: '',
        confirm_pwd: ''
      },
      changeRules: {
        old_pwd: [
          { required: true, validator: validateOldPwd, trigger: 'blur' }
        ],
        new_pwd: [
          { required: true, validator: validateNewPwd, trigger: 'blur' }
        ],
        confirm_pwd: [
          { required: true, validator: validateConfirmPwd, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClick (type) {
      if (type === 'logout') {
        GetLogout().then(res => {
          if (res) {
            const isRemamber = localStorage.getItem('isRemamber')
            if (isRemamber === 'false') {
              localStorage.clear()
            }
            this.$message.success('注销成功')
            this.$router.push('/login')
          }
        })
      } else if (type === 'changePwd') {
        this.userHandleChange()
      }
    },
    userHandleClose () {
      this.change_form = {}
      this.$refs.change_form.resetFields()
      this.userDialogVisible = false
    },
    userHandleChange () {
      this.userDialogTitle = '修改密码'
      this.userDialogVisible = true
    },
    userHandleSubmit () {
      console.log(this.change_form)
      this.$refs.change_form.validate((valid) => {
        if (valid) {
          const url = PostChangePwd
          const params = { ...this.change_form }
          url(params).then(res => {
            if (res) {
              this.$message.success(res.msg)
              this.userDialogVisible = false
              this.init()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.layout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 60px;
  background-color: #263554;
  padding: 10px 20px;
  box-shadow: 0px 1px 6px 1px rgba(34, 82, 177, 0.07);
  color: #fff;
  .layout-header-right {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 50px;
    .el-dropdown {
      display: flex;
      align-items: center;
      margin-left: 30px;
      color: #fff;
      .el-dropdown-link {
        font-size: 16px;
      }
    }
  }
  .icon-xiajiantou {
    font-size: 16px;
    margin-left: 5px;
  }
}
</style>
